// Single source of truth for the 2026 / 2027 circles programme.
//
// Only structural data lives here: days, ISO times, level ids and i18n keys.
// Every visible string is resolved from the `home` namespace
// (public/locales/{lng}/home.json > programme / kids) so the three languages
// stay in sync.
//
// Rolling the site over to a new season: copy this file to
// `<new-year>.js`, edit the values, register it in ./index.js and flip
// `active`. No component has to change.
//
// Times are wall-clock in Africa/Casablanca, 24h "HH:mm".

export const academicYear = {
  id: "2026-2027",
  gregorianYear: "2026 / 2027",
  hijriYear: "1448",
  startDate: "2026-09-05", // Saturday 5 September 2026
  timeZone: "Africa/Casablanca",
  active: true,
  // ImageKit path of the season poster, e.g.
  // "/Dar-Attaoui/Programme/2026-2027/poster.png". Left null until the file is
  // uploaded — the announcement renders without it.
  poster: null,
};

// Order here is the display order of the cards.
export const programs = [
  {
    id: "girls-2026",
    category: "girls", // -> programme.categories.girls
    instructor: null, // no confirmed name for this season
    levelKeys: [],
    methodKey: null,
    sessions: [
      { day: "fri", startTime: "15:00", endTime: "18:00" },
      { day: "sun", startTime: "09:30", endTime: "11:30" },
    ],
  },
  {
    id: "women-2026",
    category: "women",
    instructor: null,
    levelKeys: ["beginner", "advanced"],
    methodKey: null,
    sessions: [
      { day: "thu", startTime: "14:30", endTime: "17:30" },
      { day: "sat", startTime: "15:30", endTime: "18:30" },
    ],
  },
  {
    id: "men-2026",
    category: "men",
    instructor: "youssefBoulaich", // -> programme.instructors.youssefBoulaich
    levelKeys: [],
    methodKey: "traditional", // -> programme.method.traditional
    sessions: [
      { day: "mon", startTime: "19:00", endTime: "21:00" },
      { day: "tue", startTime: "19:00", endTime: "21:00" },
      { day: "thu", startTime: "19:00", endTime: "21:00" },
    ],
  },
];

// Columns of the children's timetable, in display order.
export const kidsDays = ["wed", "sat", "sun"];

export const kidsLevels = [
  {
    id: "l4",
    noteKeys: ["hamz", "imala", "makharij"],
    sessions: [
      { day: "wed", startTime: "16:00", endTime: "18:00" },
      { day: "sat", startTime: "09:30", endTime: "11:30" },
      { day: "sun", startTime: "11:30", endTime: "13:30" },
    ],
  },
  {
    id: "l3",
    noteKeys: ["raa", "mudud", "makharij"],
    sessions: [
      { day: "wed", startTime: "16:00", endTime: "18:00" },
      { day: "sat", startTime: "11:30", endTime: "13:30" },
      { day: "sun", startTime: "11:30", endTime: "13:30" },
    ],
  },
  {
    id: "l2",
    noteKeys: ["istiadha", "meem", "lam", "makharij"],
    sessions: [
      { day: "wed", startTime: "16:00", endTime: "18:00" },
      { day: "sat", startTime: "11:30", endTime: "13:30" },
      { day: "sun", startTime: "09:30", endTime: "11:30" },
    ],
  },
  {
    id: "l1",
    noteKeys: ["istiadha", "noon", "meem1", "makharij"],
    sessions: [
      { day: "wed", startTime: "14:00", endTime: "16:00" },
      { day: "sat", startTime: "09:30", endTime: "11:30" },
      { day: "sun", startTime: "09:30", endTime: "11:30" },
    ],
  },
  {
    id: "midAdv",
    noteKeys: [],
    sessions: [
      { day: "wed", startTime: "14:00", endTime: "16:00" },
      { day: "sat", startTime: "09:30", endTime: "11:30" },
      { day: "sun", startTime: "09:30", endTime: "11:30" },
    ],
  },
  {
    id: "midBeg",
    noteKeys: [],
    sessions: [
      { day: "wed", startTime: "16:00", endTime: "18:00" },
      { day: "sat", startTime: "09:30", endTime: "11:30" },
      { day: "sun", startTime: "09:30", endTime: "11:30" },
    ],
  },
  {
    id: "budAdv",
    noteKeys: [],
    sessions: [
      { day: "wed", startTime: "14:00", endTime: "16:00" },
      { day: "sat", startTime: "11:30", endTime: "13:30" },
      { day: "sun", startTime: "11:30", endTime: "13:30" },
    ],
  },
  {
    id: "budBeg",
    noteKeys: [],
    sessions: [
      { day: "wed", startTime: "14:00", endTime: "16:00" },
      { day: "sat", startTime: "11:30", endTime: "13:30" },
      { day: "sun", startTime: "11:30", endTime: "13:30" },
    ],
  },
];

// Announced on the poster without a timetable yet: rendered as a badge only.
// Give it `sessions` and move it into `kidsLevels` once the hours are confirmed.
export const kidsUpcomingLevels = [{ id: "elite" }];
